import React from 'react';
import './DashboardDefault.css';
import $ from 'jquery';
import Loader from 'react-loader';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import fbIcon from '../../../../images/socialIcons/facebook.png';
import offlinePoster from '../../../../images/socialIcons/offline.jpg';
import yotubeIcon from '../../../../images/socialIcons/youtubeicon.jpg';
import twitterIcon from '../../../../images/socialIcons/twitter.png';
import twitchIcon from '../../../../images/socialIcons/twitch.png';
import rocketIcon from '../../../../images/socialIcons/rocket.png';
import calendarIcon from '../../../../images/socialIcons/calender.png';
import RtmpConfig from '../WebCamConfig/webCamConfig.js';
import instagramIcon from '../../../../images/socialIcons/Instagram.png';
import { faThumbsUp, faEdit, faThumbsDown, faCopy, faTimes, faCogs, faBullhorn, faHistory } from '@fortawesome/fontawesome-free-solid';
import ToggleButton from 'react-toggle-button';
import Hls from 'hls.js';
import Plyr from 'plyr';
import DatePicker from 'react-datepicker';
import Form from 'react-validation/build/form';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Textarea from 'react-validation/build/textarea';
import moment from 'moment';
import * as _ from 'lodash';
import {
  Row, Col, Media,
  FormGroup, Label,
  Input, InputGroup, InputGroupAddon, TextField,
  Modal, ModalHeader, ModalBody, NumericInput
} from 'reactstrap';
import MultiSelect from 'react-select';
import { pageReady, screenPageReady, stopPublisher } from '../../../../webrtc';

var seconds = 0, minutes = 0, hours = 0, timeoutId, timerCount;
var hls;
class DashboardDefault extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      details: ['FACEBOOK', 'YOUTUBE_EVENT', 'My Timeline', 'Page', 'Groups', 'YOUTUBE_GOLIVE', 'CUSTOM_RTMP'],
      wowzaBytesOutRate: 0,
      totalViewers: 0,
      rtspUrl: '',
      m3u8Url: '',
      youtubeHost: '',
      youtubeKey: '',
      youtubeFields: false,
      permanentFbToken: '',
      mapEntries: [],
      youtubeStats: {
        viewCount: 0,
        likeCount: 0,
        dislikeCount: 0,
        favoriteCount: 0,
        commentCount: 0
      },
      client_id: '242384257630-cutoeuml04eq6e80t2rpg83leu0vpm97.apps.googleusercontent.com',
      client_secret: 'fsbPEjKRlM0JnklcTfj5Sjav',
      youtubeUrl: 'https://www.googleapis.com/youtube/v3/',
      facebookSelectdPages: [],
      ytLiveVideoID: '',
      videoInfoFetchInterval: null,
      viewsIntervalId: null,
      showTitleModal: false,
      title: '',
      scheduleTitle: '',
      description: '',
      totalConnections: 0,
      youtubeTokenDetails: [],
      openScheduleModal: false,
      scheduleOptions: ['uma vez apenas', 'Diariamente', 'Semanalmente', 'Mensalmente'],
      resolutionOptions: ['2160p', '1440p', '1080p', '720p', '480p', '360p', '240p'],
      selectedScheduleType: 'uma vez apenas',
      selectedResolution: "1080p",
      startTimeOpen: false,
      endTimeOpen: false,
      startDate: moment(new Date().toISOString()).format("YYYY/MM/DD"),
      startTime: '',
      endTime: '',
      weekly: [
        { value: 'sunday', label: 'Domingo' },
        { value: 'monday', label: 'Segunda-feira' },
        { value: 'tuesday', label: 'terca-feira' },
        { value: 'wednesday', label: 'Quarta-feira' },
        { value: 'thursday', label: 'Quinta-feira' },
        { value: 'friday', label: 'Sexta-feira' },
        { value: 'saturday', label: 'Sábado' }
      ],
      dates: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        { value: '15', label: '15' },
        { value: '16', label: '16' },
        { value: '17', label: '17' },
        { value: '18', label: '18' },
        { value: '19', label: '19' },
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '23', label: '23' },
        { value: '24', label: '24' },
        { value: '25', label: '25' },
        { value: '26', label: '26' },
        { value: '27', label: '27' },
        { value: '28', label: '28' },
        { value: '29', label: '29' },
        { value: '30', label: '30' },
        { value: '31', label: '31' }
      ],
      selectedDays: [],
      selectedDates: [],
      scheduleItem: {},
      commentIndex: null,
      endTimeErorr: false,
      allToggleStreamButton: false,
      setIntervalIds: [],
      instagramModal: false,
      customStreamKey: '',
      instagramData: {},
      statusInterval: null,
      startLoader: false,
      otpModal: false,
      instagramOtp: '',
      otpBodyResult: {},
      setIntervalIds: [],
      alertMessage: [],
      isWebcam: false,
      isRtmp: true,
      wowzaBitrateTimer: null,
      streamSource: false,
      username: "",
      password: "",
      maxTitle: 100,
      maxDescription: 5000

    };


  }

  componentDidMount = () => {
    this.fetchSocialMediaStreamList();
    this.getSocialMediaList();
    this.getAddedTitle();
    this.getAlertMessageNotification();
    this.getWowzaStreamBitRate();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.statusInterval);
    clearInterval(this.state.wowzaBitrateTimer);
    this.clearTimer();
    this.setState({
      wowzaBitrateTimer: null,
      statusInterval: null
    })
  }

  getSocialMediaList = () => {
    let self = this;
    $.ajax({
      method: 'GET',
      url: '/api/v1/facebook/pages',
      success: function (success) {
        self.setState({
          facebookSelectdPages: success.response,
          startLoader: true
        });
      let statusInterval = setInterval(() => self.updateSocialMediaStatus(), 15000);
       this.setState({
         statusInterval: statusInterval
        })


        let facebookFields = _.filter(self.state.facebookSelectdPages, { privacy: 'Public', sessionStatus: true });
        sessionStorage.setItem('facebook', JSON.stringify(facebookFields));
        let activePages = self.state.facebookSelectdPages.filter((pages, i) => {
          if (pages.sessionStatus) {
            self.setState({
              allToggleStreamButton: true
            })
            if (pages.type == 'YOUTUBE') {
              // let youtubeInterval = setInterval(() => self.getYoutubeVideoReactions(pages), 60000);
              // self.state.setIntervalIds.push({
              //   intervalId: youtubeInterval,
              //   mongoId: pages._id
              // });
            }
            if (pages.privacy) {
              // let id = setInterval(() => self.getFacebookVideoReactions(pages), 60000);
              // self.state.setIntervalIds.push({
              //   intervalId: id,
              //   mongoId: pages._id
              // })
            }
            return pages;
          }
        })

        let updatedResponse = success.response;
        if (this.state.facebookSelectdPages) {
          let updatedSocialPage = this.state.facebookSelectdPages.map((oldPages, i) => {
            if (updatedResponse) {
              updatedResponse.forEach((newPages) => {
                if (((oldPages.id && newPages.id && oldPages.id == newPages.id) || (oldPages._id && newPages._id && oldPages._id == newPages._id)))
                  oldPages.sessionStatus = newPages.sessionStatus;
              })
            }
            return oldPages;
          })
          this.setState({
            facebookSelectdPages: updatedSocialPage
          })
        }

        if (!activePages.length) {
          self.setState({
            allToggleStreamButton: false
          })
          window.localStorage.removeItem('startTime');
        }
      }.bind(this),
      error: function (err) {
        // localStorage.clear();
        // window.location.href = "/";
        console.error(err);
      }.bind(this)
    });
  }

  updateSocialMediaStatus = () => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/facebook/pages',
      success: function (success) {
        let updatedResponse = success.response;
        if (this.state.facebookSelectdPages) {
          let updatedSocialPage = this.state.facebookSelectdPages.map((oldPages, i) => {
            if (updatedResponse) {
              updatedResponse.forEach((newPages) => {
                if (((oldPages.id && newPages.id && oldPages.id == newPages.id) || (oldPages._id && newPages._id && oldPages._id == newPages._id)))
                  oldPages.sessionStatus = newPages.sessionStatus;
              })
            }
            return oldPages;
          })
          this.setState({
            facebookSelectdPages: updatedSocialPage
          })
        }
      }.bind(this),
      error: function (err) {
        console.error(err);
      }.bind(this)
    });
  }

  // getYoutubeVideoReactions = (value) => {
  //   let currentTime = new Date().getTime();
  //   if (!value.access_token || value.tokenExpireTime < currentTime)
  //     return this.generateYoutubeAccessToken(value);
  //   else if (this.state.showComments && value.liveChatId)
  //     return this.getYoutubeLiveVideoChat(value);
  //   else if (this.state.showComments && !value.liveChatId)
  //     return this.getYoutubeLiveVideoChatId(value);
  //   else if (!this.state.showComments && value.access_token)
  //     return this.getYoutubeLiveVideoStats(value);
  // }

  // generateYoutubeAccessToken = (value) => {
  //   return new Promise((resolve, reject) => {
  //     let self = this;
  //     $.ajax({
  //       method: 'GET',
  //       url: '/api/v1/youtube/access_token?id=' + value._id,
  //       success: function (response) {
  //         if (response) {
  //           value.access_token = response.response.access_token;
  //           value.tokenExpireTime = new Date().getTime() + 1 * 60 * 3600
  //         }
  //         _.replace(self.state.facebookSelectdPages, { _id: value._id }, value)
  //         self.getYoutubeLiveVideoChatId(value);
  //       },
  //       error: function (error) {
  //         console.error(error);
  //       }
  //     })
  //   })
  // }

  // getYoutubeLiveVideoStats = (value) => {
  //   let self = this;
  //   if (value.access_token) {
  //     $.ajax({
  //       url: this.state.youtubeUrl + "videos?part=statistics,liveStreamingDetails&id=" + value.youtubeVideoId + "&access_token=" + value.access_token,
  //       method: 'GET',
  //       dataType: 'jsonp',
  //       cache: false,
  //       success: function (success) {
  //         value.youtubeStats = success.items[0].statistics;
  //         _.replace(self.state.facebookSelectdPages, { _id: value._id }, value)
  //       },
  //       error: function (err) {
  //         console.error(err);
  //       }
  //     });
  //   }
  // }

  // getYoutubeLiveVideoChatId = (value) => {
  //   let self = this;
  //   $.ajax({
  //     url: this.state.youtubeUrl + 'liveBroadcasts/?part=status,contentDetails,snippet,id&broadcastStatus=active&broadcastType=persistent&access_token=' + value.access_token,
  //     method: 'GET',
  //     dataType: 'jsonp',
  //     cache: false,
  //     success: function (success) {
  //       if (success && success.items)
  //         value.liveChatId = success.items[0].snippet.liveChatId;
  //       _.replace(self.state.facebookSelectdPages, { _id: value._id }, value)
  //       self.getYoutubeLiveVideoChat(value);
  //     },
  //     error: function (err) {
  //       console.error(err);
  //     }
  //   })
  // }

  // getYoutubeLiveVideoChat = (value) => {
  //   let self = this;
  //   $.ajax({
  //     url: this.state.youtubeUrl + "liveChat/messages?part=snippet,id,authorDetails&liveChatId=" + value.liveChatId + "&access_token=" + value.access_token,
  //     method: 'GET',
  //     dataType: 'jsonp',
  //     cache: false,
  //     success: (success) => {
  //       const { items: chatList } = success;
  //       const ytChatList = chatList.map(chat => {
  //         const { authorDetails: { profileImageUrl, displayName }, snippet: { displayMessage, liveChatId } } = chat;
  //         return {
  //           profileImageUrl,
  //           displayName,
  //           displayMessage,
  //           liveChatId
  //         }
  //       });
  //       value.youtubeChatList = ytChatList
  //       _.replace(self.state.facebookSelectdPages, { _id: value._id }, value)
  //     },
  //     error: function (err) {
  //       console.log(err);
  //     }
  //   })
  // }


  getFacebookVideoReactions = (value) => {
    let self = this;
    $.ajax({
      url: "https://graph.facebook.com/v15.0/" + value.streamId,
      method: 'GET',
      data: {
        access_token: value.access_token,
        fields: 'live_views,'
          + 'reactions.type(HAHA).limit(0).summary(total_count).as(reactions_haha),'
          + 'reactions.type(LIKE).limit(0).summary(total_count).as(reactions_like),'
          + 'reactions.type(LOVE).limit(0).summary(total_count).as(reactions_love),'
          + 'reactions.type(WOW).limit(0).summary(total_count).as(reactions_wow),'
          + 'reactions.type(SAD).limit(0).summary(total_count).as(reactions_sad),'
          + 'reactions.type(ANGRY).limit(0).summary(total_count).as(reactions_angry)'

      },
      global: false,
      success: (success) => {
        value.reactions = {
          facebookViews: success.live_views,
          facebookLikesCount: success.reactions_like.summary.total_count,
          facebookLoveCount: success.reactions_love.summary.total_count,
          facebookHaHaCount: success.reactions_haha.summary.total_count,
          facebookWowCount: success.reactions_wow.summary.total_count,
          facebookSadCount: success.reactions_sad.summary.total_count,
          facebookAngryCount: success.reactions_angry.summary.total_count
        }
        self.addAllViews();
        _.replace(self.state.facebookSelectdPages, { _id: value._id }, value)
      },
      error: function (err) {
        console.error(err);
      }
    })
  }

  addAllViews = () => {
    this.state.facebookSelectdPages.forEach((views) => {
      if (views && views.reactions && views.reactions.facebookViews) {
        this.setState({
          totalViewers: this.state.totalViewers + parseInt(views.reactions.facebookViews)
        })
      }
    })
  }

  fetchSocialMediaStreamList = () => {
    const wowzaAppName = localStorage.getItem('wowzaAppName')
    if (window.location.hostname == 'app.relaystream.io' || window.location.hostname.includes("localhost")) {
      var rtmpUrl = "rtmp://saopaulo01.relaystream.io:1935/" + wowzaAppName;
      var m3u8Url = "https://5ad482a77183d.streamlock.net/" + wowzaAppName + '/' + wowzaAppName + '/playlist.m3u8';
    }
    else {
      var rtmpUrl = "rtmp://localhost:1935/" + wowzaAppName;
      var m3u8Url = window.location.protocol + "//" + 'localhost' + ':1935/' + wowzaAppName + '/' + wowzaAppName + '/playlist.m3u8';
    }
    this.setState({
      m3u8Url: m3u8Url,
      rtmpUrl: rtmpUrl
    });
    return {
      m3u8Url: m3u8Url,
      rtmpUrl: rtmpUrl
    }
  }

  playHlsVideo = (m3u8Url) => {
    const source = m3u8Url;
    const video = document.querySelector('#localVideo');
    if(video){
      video.controls = true;
      video.autoplay = true;
      video.muted = false;
    }
    const player = new Plyr(video, { captions: { active: true, update: true, language: 'en' } });
    hls = new Hls();
    if (!Hls.isSupported()) {
      video.src = source;
    } else {
      hls.loadSource(source);
      hls.attachMedia(video);
      window.hls = hls;
      window.player = player;
      // Handle changing captions
      player.on('languagechange', () => {
        hls.subtitleTrack = player.currentTrack
      });
    }
    this.setState({
      streamSource: true
    })
    window.player = player;
  }

  timer = () => {
    timeoutId = setInterval(() => {
      var endTime = new Date().getTime();
      var timeDiff = endTime - window.localStorage.getItem('startTime');
      timeDiff /= 1000;
      seconds = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);
      minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);
      hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);
      timerCount = (hours ? (hours > 9 ? hours : "0" + hours) : "00") + ":" + (minutes ? (minutes > 9 ? minutes : "0" + minutes) : "00") + ":" + (seconds > 9 ? seconds : "0" + seconds);
      this.setState({
        LiveTimer: timerCount
      });
    }, 1000);
  }

  clearTimer = () => {
    this.state.setIntervalIds.forEach((interval) => {
      clearInterval(interval.intervalId);
    })
    seconds = 0;
    minutes = 0;
    hours = 0;
    timerCount = (hours ? (hours > 9 ? hours : "0" + hours) : "00") + ":" + (minutes ? (minutes > 9 ? minutes : "0" + minutes) : "00") + ":" + (seconds > 9 ? seconds : "0" + seconds);
    return timerCount;
  }

  facebookStartStopBroadcast = (dest, stopStream) => {
    if(!this.state.isOnline && !dest.sessionStatus) return;
    this.setState({ startLoader: !this.state.startLoader })
    let self = this;
    let data = {
      title: dest.title,
      description: dest.description,
      id: dest.id,
      name: dest.name,
    }
    let url;
    if (stopStream) {
      url = "/api/v1/facebook/stop/broadcast";
      self.clearTimer(dest._id);
    }
    else
      url = "/api/v1/facebook/start/broadcast";
    $.ajax({
      url: url,
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        this.setState({ startLoader: !this.state.startLoader })
        if (resp.status == 200) {
          setTimeout(function () {
            self.getSocialMediaList();
          }, 4000);
          this.props.notifySuccess(resp.message);
        }
      }.bind(this),
      error: function (errorData) {
        this.setState({ startLoader: !this.state.startLoader })
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    });
  }
  startStopInstagramBroadcast = (dest, stopStream) => {
    if(!this.state.isOnline && !dest.sessionStatus) return;
    this.setState({ startLoader: !this.state.startLoader })
    let self = this;
    let url;
    if (stopStream)
      url = "/api/v1/instagram/stop/broadcast";
    else
      url = "/api/v1/instagram/start/broadcast";

    let data = {
      instagramId: dest.instagramId,
      m3u8Url: this.state.m3u8Url,
      id: dest._id,
      rotate: dest.broadcastType ? dest.broadcastType : 'normal',
      title: this.state.title,
      description: this.state.description
    }
    $.ajax({
      url: url,
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        this.setState({ startLoader: !this.state.startLoader })
        if (resp.response && resp.response.two_factor_identifier) {
          resp.response.id = dest._id;
          this.setState({
            otpModal: !this.state.otpModal,
            instagramOtp: '',
            otpBodyResult: resp.response,
          })
        } else {
          setTimeout(function () {
            self.getSocialMediaList();
          }, 5000);
          this.props.notifySuccess(resp.message);
        }
      }.bind(this),
      error: function (errorData) {
        this.setState({ startLoader: !this.state.startLoader })
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    });
  }


  startCustomBroadcast = (dest, stopStream) => {
    if(!this.state.isOnline && !dest.sessionStatus) return;
    let self = this;
    let data = {
      title: dest.title,
      description: dest.description,
      resolution: dest.resolution ? dest.resolution : this.state.selectedResolution,
      customRtmp: dest.customRtmp,
      customStreamKey: dest.customStreamKey,
      id: dest._id,
      platformType: dest.platformType,
      name: dest.name,
      username: dest.custom_username,
      password: dest.custom_password,
      // refresh_token: dest.refresh_token,
      type: dest.type,
      startTime: new Date().toISOString(),
      isWebcam: this.state.isWebcam ? this.state.isWebcam : this.state.isScreen
    }
    if(data.platformType === "Instagram") { 
      data.rotate = dest.broadcastType;
      data.m3u8Url = this.state.m3u8Url;
      data.instagramId = dest._id;
    }

    let url;
    if (stopStream) {
      url = "/api/v1/facebook/stop/broadcast";
      self.clearTimer();
    }
    else {
      if (dest.type == 'YOUTUBE') url = "/api/v1/start/youtube/broadcast";
      if (dest.type == 'CUSTOM') url = "/api/v1/start/custom/broadcast";
    }
    this.setState({ startLoader: !this.state.startLoader })

    $.ajax({
      url: url,
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        this.setState({ startLoader: !this.state.startLoader })
        if (resp.status == 200) {
          setTimeout(function () {
            self.getSocialMediaList();
          }, 6000);
          this.props.notifySuccess(resp.message);
        }
      }.bind(this),
      error: function (errorData) {
        this.setState({ startLoader: !this.state.startLoader })
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    });
  }

  openModalFromHeader = (header) => {
    if (header == 'title')
      this.setState({ showTitleModal: true });
    if (header == 'pages')
      this.setState({ showComments: false });
  }
  toggleTitleModalPopup = () => {
    if (this.state.showTitleModal)
      this.setState({ showTitleModal: false });
  }

  updateTitleForAllPlatform = (event) => {
    event.preventDefault();
    let self = this;
    this.setState({ showTitleModal: false });
    let data = {
      title: this.state.title,
      description: this.state.description,
      resolution: this.state.selectedResolution
    }
    $.ajax({
      url: '/api/v1/update/title',
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        self.getSocialMediaList();
        this.props.notifySuccess(resp.message);
      }.bind(this),
      error: function (errorData) {
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    });
  }

  getAddedTitle = () => {
    $.ajax({
      url: '/api/v1/update/title',
      method: 'GET',
      success: function (resp) {
        if (resp.response) {
          this.setState({
            title: resp.response.title,
            description: resp.response.description,
            selectedResolution: resp.response.resolution ? resp.response.resolution : this.state.selectedResolution
          })
        }
      }.bind(this),
      error: function (error) {
        console.error(error);
      }.bind(this)
    })
  }


  getAlertMessageNotification = () => {
    $.ajax({
      url: '/api/v1/notification/alert',
      method: 'GET',
      success: function (resp) {
        this.setState({
          alertMessage: resp.response
        })
      }.bind(this),
      error: function (error) {
        console.error(error);
      }.bind(this)
    })
  }

  changeTitle = (e) => {
    e.preventDefault();
    const newValue = e.target.value;
    if (newValue.length <= this.state.maxTitle) {
      // this.setState({ text: newValue });
      this.setState({ title: newValue });
    }
  }

  changeDescription = (e) => {
    e.preventDefault();
    const newValue = e.target.value;
    if (newValue.length <= this.state.maxDescription) {
      this.setState({ description: newValue });
    }

  }

  toggleScheduleModal = (dest) => {
    let minutes = new Date().getMinutes().toString();
    let hours = new Date().getHours().toString();
    if (minutes.length == 1) {
      minutes = "0" + minutes;
    }
    if (hours.length == 1) {
      hours = "0" + hours;
    }
    this.setState({
      openScheduleModal: !this.state.openScheduleModal,
      startTime: moment(hours + minutes, "hmm").format("HH:mm"),
      endTime: moment(hours + minutes, "hmm").format("HH:mm"),
      scheduleItem: dest,
      selectedScheduleType: this.state.scheduleOptions[0],
      selectedDates: [],
      selectedDays: []
    })
  }

  addScheduleEvent = (event) => {
    event.preventDefault();
    let data = this.getScheduleRequestBody();
    $.ajax({
      url: '/api/v1/schedule',
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        this.setState({
          openScheduleModal: !this.state.openScheduleModal
        })
        this.props.notifySuccess(resp.message);
      }.bind(this),
      error: function (errorData) {
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    })
  }

  getScheduleRequestBody = () => {
    let data = {
      scheduleType: this.state.selectedScheduleType,
      selectedDays: this.convertSelectedDaysIntoArray(this.state.selectedDays),
      startDate: this.state.startDate,
      startTime: this.state.startTime,
      endTime: this.state.endTime,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      selectedDates: this.convertSelectedDaysIntoArray(this.state.selectedDates),
      description: this.state.description,
      title: this.state.title,
      resolution: this.state.selectedResolution
    }
    if (this.state.scheduleItem.type == 'YOUTUBE' || this.state.scheduleItem.type == "CUSTOM" || this.state.scheduleItem.type == "PERISCOPE") {
      data.customRtmp = this.state.scheduleItem.customRtmp;
      data.customStreamKey = this.state.scheduleItem.customStreamKey;
      data.id = this.state.scheduleItem._id;
      data.platformType = this.state.scheduleItem.platformType;
      // data.refresh_token = this.state.scheduleItem.refresh_token;
      data.name = this.state.scheduleItem.name;
      data.type = this.state.scheduleItem.type;
    }
    else {
      data.privacy = this.state.scheduleItem.privacy;
      data.id = this.state.scheduleItem.id;
      data.access_token = this.state.scheduleItem.access_token;
      data.name = this.state.scheduleItem.name;
      data.type = 'FACEBOOK';
    }
    return data;
  }

  activeAllStream = (active) => {
    if(!this.state.isOnline) return;
    let method = 'DELETE';
    if (active)
      method = 'POST';
    let data = {
      allPages: this.updateAllYoutubeScheduleStartTime(this.state.facebookSelectdPages)
    }
    let self = this;
    this.setState({ startLoader: !this.state.startLoader })
    $.ajax({
      url: '/api/v1/updateAllStream',
      method: method,
      data: JSON.stringify(data),
      success: (result) => {
        self.setState({ startLoader: !self.state.startLoader })
        self.props.notifySuccess(result.message);
        setTimeout(() => { self.getSocialMediaList(); }, 1000)
      },
      error: function (errorData) {
        self.setState({ startLoader: !self.state.startLoader })
        self.props.notifyError(errorData.responseJSON.message);
      }
    })
  }

  updateAllYoutubeScheduleStartTime = (facebookSelectdPages) => {
    if (!facebookSelectdPages.length) return facebookSelectdPages;
    return facebookSelectdPages.map((pages) => {
      if (pages.type == "YOUTUBE") pages.startTime = new Date().toISOString();
      return pages;
    })
  }

  convertSelectedDaysIntoArray = (selectedDays) => {
    if (selectedDays && selectedDays.length) {
      return selectedDays.map((days) => {
        return days.value;
      })
    }
  }
  selectScheduleType = (e) => {
    this.setState({ selectedScheduleType: e.target.value });
  }

  selectResoultion = (e) => {
    this.setState({ selectedResolution: e.target.value });
  }

  scheduleOptions = () => {
    return this.state.scheduleOptions.map((option, i) => {
      return (<option key={i} value={option}>{option}</option>)
    })
  }

  resolutionOptions = () => {
    return this.state.resolutionOptions.map((option, i) => {
      return (<option key={i} value={option}>{option}</option>)
    })
  }

  customSocialMediaStreamKey = (e) => {
    this.setState({ customStreamKey: e.target.value });
  }

  editInstagramStreamKey = (dest) => {
    this.setState({
      instagramModal: !this.state.instagramModal,
      customStreamKey: dest.customStreamKey,
      instagramData: dest
    });
  }

  onChangeOtpText = (e) => {
    this.setState({ instagramOtp: e.target.value });
  }

  submitInstagramOtp = (event) => {
    event.preventDefault();
    if (this.state.instagramOtp.length == 6) {
      this.setState({
        otpModal: !this.state.otpModal
      })
      this.submitOtpWithBody();
    }
  }

  submitOtpWithBody = () => {
    let self = this;
    let data = this.state.otpBodyResult;
    data.verifiedToken = this.state.instagramOtp;
    data.startBroadcast = true;
    data.tite = this.state.title;
    data.description = this.state.description;
    this.setState({
      startLoader: false
    })
    $.ajax({
      method: 'POST',
      url: '/api/v1/instagram/verification/otp',
      data: JSON.stringify(data),
      success: (success) => {
        this.setState({
          startLoader: true
        })
        this.props.notifySuccess(success.message);
        setTimeout(function () {
          self.getSocialMediaList();
        }, 5000);

      },
      error: (err) => {
        this.setState({
          startLoader: true,
          otpModal: true
        })
        if(err) self.props.notifyError(err.responseJSON.message);
      }
    });
  }


  updateCustomInstagramModal = (event) => {
    event.preventDefault();
    let data = {
      _id: this.state.instagramData._id,
      customStreamKey: this.state.customStreamKey
    }
    $.ajax({
      method: 'PUT',
      url: '/api/v1/social/media',
      data: JSON.stringify(data),
      success: (success) => {
        if (success) {
          this.setState({ instagramModal: !this.state.instagramModal })
          this.props.notifySuccess(success.message);
          this.getSocialMediaList();
        }
      },
      error: (err) => {
        if(err) this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  disableInstagramModal = () => {
    this.setState({ instagramModal: !this.state.instagramModal })
  }
  disableOtpInstagramModal = () => {
    this.setState({ otpModal: !this.state.otpModal })
  }

  onChangeStartTime = (e) => {
    this.setState({
      startTime: e.target.value
    });
  }
  onChangeEndTime = (e) => {
    this.setState({
      endTime: e.target.value
    });
  }


  onStartDateChange = (date) => {
    this.setState({ startDate: moment(date._d).format("YYYY/MM/DD") })
  }


  selectedDays = (selectedDays) => {
    this.setState({
      selectedDays: selectedDays
    })
  }

  selectMultipleDates = (selectedDates) => {
    this.setState({
      selectedDates: selectedDates
    })
  }

  startTimerOpen = () => {
    this.setState({
      startTimeOpen: !this.state.startTimeOpen
    })
  }

  changeWebRtmpStrip = (type) => {
    if (this.state.streamSource) return this.props.notifyError("Please disable stream on your rtmp url");
    this.setState({
      startLoader: !this.state.startLoader
    })
    // if (type == 'webcam') {
    //   this.setState({ isWebcam: true, isScreen: false, isRtmp: false })
    //   this.enabledWebrtcFeatures();
    // }
    if (type == 'rtmp') {
      this.setState({ isWebcam: false, isScreen: false, isRtmp: true })
      this.enabledRtmpFeatures();
    }
    // if (type == 'screen') {
    //   this.setState({ isWebcam: false, isScreen: true, isRtmp: false })
    //   this.enabledScreenShare();
    // }
  }

  enabledScreenShare = () => {
    let self = this;
    $.ajax({
      method: 'PUT',
      url: '/api/v1/enable/webrtc?isEnabled=true',
      success: (success) => {
        clearInterval(this.state.wowzaBitrateTimer);
        // screenPageReady()
        //   .then((result) => {
        //     if (result) {
        //       window.localStorage.setItem('screenIsEnabled', true);
        //       this.setState({
        //         isScreen: true, isWebcam: false, isRtmp: false,
        //         startLoader: true, streamSource: false, isOnline: true
        //       })
        //       let m3u8Url = self.state.m3u8Url.split("/playlist.m3u8");
        //       m3u8Url = m3u8Url[0] + "_1080p" + m3u8Url[1] + "/playlist.m3u8";
        //       console.log('self', m3u8Url)
        //       return self.playHlsVideo(m3u8Url);
        //     } else {
        //       window.localStorage.setItem('screenIsEnabled', false);
        //       this.setState({
        //         isWebcam: false, isRtmp: true, isScreen: false,
        //         startLoader: true, streamSource: false, isOnline: false
        //       })
        //     }
        //   });
      },
      error: (err) => {
        if(err) this.props.notifyError(err.responseJSON.message);
      }
    })
  }

  enabledRtmpFeatures = () => {
    $.ajax({
      method: 'PUT',
      url: '/api/v1/enable/webrtc?isEnabled=false',
      success: (success) => {
        window.localStorage.setItem('webCamIsEnabled', false);
        window.localStorage.setItem('screenIsEnabled', false);
        stopPublisher();
        this.stopWebCamera();
        this.toggleWebCamButton();
        this.getWowzaStreamBitRate();
      },
      error: (err) => {
        if(err) this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  enabledWebrtcFeatures = () => {
    $.ajax({
      method: 'PUT',
      url: '/api/v1/enable/webrtc?isEnabled=true',
      success: (success) => {
        let videoElement = document.getElementById('localVideo');
        videoElement.load();
        clearInterval(this.state.wowzaBitrateTimer);
        this.setState({ isWebcam: true, isScreen: false, isRtmp: false })
        return pageReady()
          .then((result) => {
            if (result) {
              window.localStorage.setItem('webCamIsEnabled', true);
              this.setState({
                isOnline: true, startLoader: true, streamSource: false
              })
            } else {
              window.localStorage.setItem('webCamIsEnabled', false);
              this.setState({
                isWebcam: false, isRtmp: true, isScreen: false, isOnline: false,
                startLoader: !this.state.startLoader, streamSource: false
              })
            }
          });
      },
      error: (err) => {
        this.setState({ isWebcam: false, startLoader: !this.state.startLoader })
        if(err) this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  toggleWebCamButton = () => {
    setTimeout(() => {
      this.setState({
        isWebcam: false,
        isRtmp: true,
        isScreen: false,
        startLoader: !this.state.startLoader,
        streamSource: false
      })
      this.wowzaBitRateAjax();
    }, 2000)
  }

  getWebrtcIsEnabled = () => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/enable/webrtc',
      success: (success) => {
        this.setState({
          isWebcam: success.response.enablePublish
        })
        let webCamIsEnabled = JSON.parse(window.localStorage.getItem('webCamIsEnabled'));
        let screenIsEnabled = JSON.parse(window.localStorage.getItem('screenIsEnabled'));
        if (success.response.enablePublish && (webCamIsEnabled || screenIsEnabled)) {
          if (webCamIsEnabled) this.enabledWebrtcFeatures();
          if (screenIsEnabled) this.enabledScreenShare();
        } else {
          this.getWowzaStreamBitRate();
        }
      },
      error: (err) => {
        if(err.responseJSON) this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  getWowzaStreamBitRate = () => {
    this.wowzaBitRateAjax();
    let bitrateTimer = setInterval(() => {
       this.wowzaBitRateAjax();
     }, 15000);
    this.setState({
      wowzaBitrateTimer: bitrateTimer
    })
  }


  wowzaBitRateAjax = () => {
    let self = this;
    $.ajax({
      url: '/api/v1/bitrate',
      method: 'GET',
      success: function (resp) {
        if (resp.response.bytesInRate > 0) {
          self.setState({ isOnline: true, totalConnections: resp.response.totalConnections })
          if (!self.state.isWebcam && !self.state.streamSource) {
            self.fetchSocialMediaStreamList();
            return self.playHlsVideo(self.state.m3u8Url);
          }
        }
        else {
          let videoElement = document.getElementById('localVideo');
          if (!videoElement) return;
          videoElement.removeAttribute('src');
          videoElement.controls = false;
          videoElement.autoplay = false;
          videoElement.load();
          this.stopWebCamera();
          self.setState({ isOnline: false, streamSource: false })
        }
      }.bind(this),
      error: function (error) {
        console.error(error);
      }.bind(this)
    })
  }

  stopWebCamera = () => {
    const video = document.querySelector('video');
    const mediaStream = video.srcObject;
    this.setState({
      isWebcam: false,
      isScreen: false,
      isRtmp: true
    })
    if (mediaStream) {
      const tracks = mediaStream.getTracks();
      tracks[0].stop();
      tracks.forEach(track => track.stop())
    }
  }

  getRtmpConfigData = () => {
    var wowzaAppName = localStorage.getItem('wowzaAppName');
    if (window.location.hostname == 'app.relaystream.io') {
      var rtmpUrl = "rtmp://saopaulo01.relaystream.io:1935/" + wowzaAppName;
      var m3u8Url = "https://5ad482a77183d.streamlock.net/" + wowzaAppName + '/' + wowzaAppName + '/playlist.m3u8';
    }
    else {
      var rtmpUrl = "rtmp://localhost:1935/" + wowzaAppName;
      var m3u8Url = window.location.protocol + "//" + 'localhost' + ':1935/' + wowzaAppName + '/' + wowzaAppName + '/playlist.m3u8';
    }
    return {
      rtmpUrl: rtmpUrl,
      m3u8Url: m3u8Url,
      isWebcam: this.state.isWebcam
    }
  }

  startStopPeriScpopeBroadcast = (dest, stopBroadcast) => {
    if(!this.state.isOnline) return;
    let url = "/api/v1/twitter/broadcast";
    if (stopBroadcast) url = "/api/v1/twitter/broadcast/stop";
    let self = this;
    let data = {
      id: dest.id,
      description: this.state.description,
      title: this.state.title,
      isWebcam: this.state.isWebcam ? this.state.isWebcam : false
    }
    this.setState({ startLoader: !this.state.startLoader })
    $.ajax({
      url: url,
      method: 'POST',
      data: JSON.stringify(data),
      success: function (resp) {
        this.setState({ startLoader: !this.state.startLoader })
        if (resp.status == 200) {
          setTimeout(function () {
            self.getSocialMediaList();
          }, 6000);
          this.props.notifySuccess(resp.message);
        }
      }.bind(this),
      error: function (errorData) {
        this.setState({ startLoader: !this.state.startLoader })
        this.props.notifyError(errorData.responseJSON.message);
      }.bind(this)
    })
  }

  getRadioButtonValue = (dest, event) => {
    let self = this;
    $.ajax({
      url: "/api/v1/update/instagram?id=" + dest.id + "&type=" + event.target.value,
      method: 'GET',
      success: function (resp) {
        // this.setState({ startLoader: !this.state.startLoader })
        self.getSocialMediaList();
      }.bind(this),
      error: function (errorData) {
        console.log('error->', errorData)
      }.bind(this)
    })
  }


  render() {

    return (
      <div className="container-fluid">
        <div className="row dashboardPage">
          <div className="col-md-8 col-sm-10 col-xs-7 relay-header">
            <h3 className="dashboard-Title forsmallSidebar">Bem Vindo ao Relay Stream</h3>
            <h4 className="relay-border-bottom forsmallSidebar">
              <div className="relay-icons">
                <a className="col-md-10 titleHeader" onClick={() => { this.openModalFromHeader('pages') }}>PAINEL DE CONTROLE</a>
                <a className="col-md-8 titleHeader" onClick={() => { this.openModalFromHeader('title') }}>TÍTULO</a>

              </div>
              {/* <Row>
                <Col className="titleColumn titleFlex">
                </Col>
                <Col className="titleColumn">
                </Col>
              </Row> */}
            </h4>
            <div className="col-md-12 relay-icons">
              <button className="btn add-button forsmallSidebar" onClick={()=>  this.props.history.push("social/platform") }>
                <i className="fa fa-plus" aria-hidden="true"></i> Adicionar canal</button>
              <label>
                {/* <span className="altr-mar">Alternar tudo</span> */}
                {/* <div className="custom-togglebutton">
                  <ToggleButton />
                </div> */}
                {/* <div className="custom-togglebutton">
                  <ToggleButton
                    value={this.state.allToggleStreamButton ? true : false}
                    onToggle={() => { this.state.allToggleStreamButton ? this.activeAllStream() : this.activeAllStream(true) }} />
                </div> */}
              </label>

            </div>

            <Loader loaded={this.state.startLoader}>
              {/* <Profile model={this.state.profile} /> */}
            </Loader>
            <Media list className="p-0 scrollmenu list-view">
              <div className="containerSpan col-lg-12 col-sm-10 col-xs-4 list-text">
                <div className="socialHeader">{this.state.showComments ? "" : "Social"}</div>
                {/* <div className="viewHeader">{this.state.showComments ? "" : "Visão"}</div> */}
                {/* <div className="reactionHeader">{this.state.showComments ? "" : "Reações"}</div> */}
                <div className="scheduleHeader">{this.state.showComments ? "" : "Agenda"}</div>
                <div className="statusHeader">{this.state.showComments ? "" : "Status"}</div>
                {/* <div className="editHeader">{this.state.showComments ? "" : "Edit"}</div> */}
              </div>
              {
                this.state.facebookSelectdPages.length ?
                  this.state.facebookSelectdPages.map((dest, i) => {
                    if (!this.state.showComments) {
                      if (dest.type == 'CUSTOM' && dest.selected) {
                        let icon = dest.platformType == 'Twitter' ? twitterIcon : dest.platformType == 'Youtube' ? yotubeIcon :
                          dest.platformType == 'Twitch' ? twitchIcon : dest.platformType == 'Instagram' ? instagramIcon : dest.platformType == 'Facebook' ? fbIcon : rocketIcon;
                        return (
                          <Media tag="li" className="stat-item rounded mb-3 p-sm-0 py-sm-1 pr-sm-4" key={i}>
                            <Media left tag="span" className="facebook-icon stat-item__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                              <Media object src={icon} className="circle mr-2 fbImageIcon" alt="fb icon" />
                              <span className="stat-item__platform__details d-flex flex-column">
                                <span className="dest-name">{`${dest.name} - Custom`}</span>
                              </span>
                            </Media>                            
                            {dest.platformType === "Instagram" ? <Media className={`youtubeReactions insta-radio`} onChange={(event) => this.getRadioButtonValue(dest, event)} >
                              <input className="radio-btn ml-1" type="radio" value="normal" defaultChecked={dest.broadcastType == 'normal' ? true : false} name={dest.id} /> Normal
                              <input className="radio-btn ml-1" type="radio" value="paisagem" defaultChecked={dest.broadcastType == 'paisagem' ? true : false} name={dest.id} /> Paisagem
                              <input className="radio-btn ml-1" type="radio" value="square" defaultChecked={dest.broadcastType == 'square' ? true : false} name={dest.id} /> Square
                            </Media> : <div className="stat-item__reactions text-center mb-3 mb-sm-0 "></div>}
                            
                            <Media right tag="span" className="stat-item__status d-flex custom_calendar">
                              {
                                !this.state.isWebcam || !this.state.isScreen ?
                                  <img src={calendarIcon} className="calendar" onClick={() => { this.toggleScheduleModal(dest) }} />
                                  : ''
                              }
                            </Media>
                            <Media right tag="span" className={dest.platformType == 'Instagram' ? "instagram-toggle d-flex p-1" : "statusToggle d-flex p-1"}>
                              <ToggleButton
                                value={dest.sessionStatus ? true : false}
                                onToggle={() => dest.sessionStatus ? this.startCustomBroadcast(dest, true) : this.startCustomBroadcast(dest)} />
                            </Media>
                            {dest.platformType == 'Instagram' ?
                              <Media className="edit-status">
                                <button
                                  title="Edit"
                                  className="button-reset px-3"
                                  onClick={() => this.editInstagramStreamKey(dest)}>
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                              </Media> : ''
                            }
                          </Media>)
                      }
                      else if (dest.type == 'YOUTUBE' && dest.selected) {
                        return (
                          <Media tag="li" className="stat-item rounded mb-3 p-1 p-sm-0 py-sm-1 pr-sm-4" key={i}>
                            <Media className="facebook-icon stat-item__youtube__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                              <Media object src={dest.profilePic} className="circle mr-2 fbImageIcon" alt="fb icon" />
                              <div className="stat-item__platform__details d-flex flex-column">
                                <span className="dest-name">{`${dest.name} - Youtube`}</span>
                              </div>
                              <div>
                                <span tag="span" className="viewCount mb-3 mb-sm-0">
                                  {/* {dest.youtubeStats && dest.youtubeStats.viewCount ? dest.youtubeStats.viewCount : 0} */}
                                </span>
                              </div>
                            </Media>
                            {/* <Media className={`youtubeReactions stat-item__reactions mb-3 mb-sm-0`} >
                              <Media className="like d-flex">
                                <FontAwesomeIcon icon={faThumbsUp} />
                                {dest.youtubeStats && dest.youtubeStats.likeCount ? dest.youtubeStats.likeCount : 0}
                              </Media>
                              <Media className="dislike d-flex">
                                <FontAwesomeIcon icon={faThumbsDown} />
                                {dest.youtubeStats && dest.youtubeStats.dislikeCount ? dest.youtubeStats.dislikeCount : 0}
                              </Media>
                            </Media> */}
                            <Media className="stat-item__status d-flex p-1 custom-youtube">
                              {
                                !this.state.isWebcam || !this.state.isScreen ?
                                  <img src={calendarIcon} className="calendar" onClick={() => { this.toggleScheduleModal(dest) }} />
                                  : ''
                              }
                            </Media>
                            <Media className="youtube-toggle d-flex p-1">
                              <ToggleButton
                                value={dest.sessionStatus ? true : false}
                                onToggle={() => dest.sessionStatus ? this.startCustomBroadcast(dest, true) : this.startCustomBroadcast(dest)} />
                            </Media>
                          </Media>
                        )
                      } 
                      // else if (dest.type == 'PERISCOPE' && dest.selected) {
                      //   return (
                      //     <Media tag="li" className="stat-item rounded mb-3 p-1 p-sm-0 py-sm-1 pr-sm-4" key={i}>
                      //       <Media className="facebook-icon stat-item__youtube__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                      //         <Media object src={dest.profilePic} className="circle mr-2 fbImageIcon" alt="fb icon" />
                      //         <div className="stat-item__platform__details d-flex flex-column">
                      //           <span className="dest-name">{dest.name}</span>
                      //         </div>
                      //         {/* <div>
                      //           <span tag="span" className="viewCount mb-3 mb-sm-0">
                      //             {dest.youtubeStats && dest.youtubeStats.viewCount ? dest.youtubeStats.viewCount : 0}
                      //           </span>
                      //         </div> */}
                      //       </Media>
                      //       <div className="stat-item__reactions text-center mb-3 mb-sm-0 ">
                      //       </div>
                      //       <Media className="stat-item__status d-flex p-1">
                      //         {
                      //           !this.state.isWebcam || !this.state.isScreen ?
                      //             <img src={calendarIcon} className="calendar" onClick={() => { this.toggleScheduleModal(dest) }} />
                      //             : ''
                      //         }
                      //       </Media>
                      //       <Media className="youtube-toggle d-flex p-1">
                      //         <ToggleButton
                      //           value={dest.sessionStatus ? true : false}
                      //           onToggle={() => dest.sessionStatus ? this.startStopPeriScpopeBroadcast(dest, true) : this.startStopPeriScpopeBroadcast(dest)} />
                      //       </Media>
                      //     </Media>
                      //   )
                      // }
                      else if (dest.type == 'INSTAGRAM' && dest.selected) {

                        return (
                          <Media tag="li" className="stat-item rounded mb-3 p-1 p-sm-0 py-sm-1 pr-sm-4" key={i}>
                            <Media className="facebook-icon stat-item__youtube__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                              <Media object src={instagramIcon} className="circle mr-2 fbImageIcon" />
                              <div className="stat-item__platform__details d-flex flex-column">
                                <span className="dest-name ">{dest.name ? dest.name : dest.email}</span>
                              </div>
                              <div>
                                <span tag="span" className="viewCount mb-3 mb-sm-0">
                                  {/* {dest.youtubeStats && dest.youtubeStats.viewCount ? dest.youtubeStats.viewCount : 0} */}
                                </span>
                              </div>
                            </Media>
                            <Media className={`youtubeReactions   insta-radio`} onChange={(event) => this.getRadioButtonValue(dest, event)} >
                              <input className="radio-btn" type="radio" value="normal" defaultChecked={dest.broadcastType == 'normal' ? true : false} name={dest.instagramId} /> Normal
                              <input className="radio-btn" type="radio" value="paisagem" defaultChecked={dest.broadcastType == 'paisagem' ? true : false} name={dest.instagramId} /> 	Paisagem
                              <input className="radio-btn" type="radio" value="square" defaultChecked={dest.broadcastType == 'square' ? true : false} name={dest.instagramId} /> Square

                            </Media>
                            <Media className="youtube-toggle d-flex p-1 insta-toggle">
                              <ToggleButton
                                value={dest.sessionStatus ? true : false}
                                onToggle={() => dest.sessionStatus ? this.startStopInstagramBroadcast(dest, true) : this.startStopInstagramBroadcast(dest)}
                              />
                            </Media>
                          </Media>
                        )
                      } else if (!dest.platformType) {
                        return (
                          <Media tag="li" className="stat-item rounded mb-3 p-sm-0 py-sm-1 pr-sm-4" key={i}>
                            <div className="facebook-icon stat-item__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                              <Media object src={dest.profilePic ? dest.profilePic : fbIcon} className="circle mr-2 fbImageIcon" alt="fb icon" />
                              <div className="stat-item__platform__details d-flex flex-column">
                                <span className="dest-name">{`${dest.name} - Facebook ${dest.type ? dest.type : 'Page'}`}</span>
                              </div>
                              {/* <span tag="span" className="viewCount mb-3 mb-sm-0">
                                {dest.reactions && dest.reactions.facebookViews ? dest.reactions.facebookViews : 0}
                              </span> */}
                            </div>

                            <div className={`stat-item__reactions text-center mb-3 mb-sm-0 ${!'if facebook' && 'faEllipsisH'}`} >
                              <div className="demo">
                                {/* <div className={`reactions reaction_box ${i == 0 ? 'reactions--bottom' : ''}`}>
                                  <div className="reactions__item">
                                    <i className="icon icon-like" data-title="like"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount likeCount">{dest.reactions && dest.reactions.facebookLikesCount ? dest.reactions.facebookLikesCount : 0}</small></span>
                                  </div>
                                  <div className="reactions__item">
                                    <i className="icon icon-love" data-title="love"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount loveCount">{dest.reactions && dest.reactions.facebookLoveCount ? dest.reactions.facebookLoveCount : 0}</small></span>
                                  </div>
                                  <div className="reactions__item">
                                    <i className="icon icon-haha" data-title="haha"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount hahaCount">{dest.reactions && dest.reactions.facebookHaHaCount ? dest.reactions.facebookHaHaCount : 0}</small></span>
                                  </div>
                                  <div className="reactions__item">
                                    <i className="icon icon-wow" data-title="wow"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount wowCount">{dest.reactions && dest.reactions.facebookWowCount ? dest.reactions.facebookWowCount : 0}</small></span>
                                  </div>
                                  <div className="reactions__item">
                                    <i className="icon icon-sad" data-title="sad"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount sadCount">{dest.reactions && dest.reactions.facebookSadCount ? dest.reactions.facebookSadCount : 0}</small></span>
                                  </div>
                                  <div className="reactions__item">
                                    <i className="icon icon-angry" data-title="angry"></i>
                                    <span className="text-dark d-block" style={{ marginTop: '-10px' }}><small className="smallCount angryCount">{dest.reactions && dest.reactions.facebookAngryCount ? dest.reactions.facebookAngryCount : 0}</small></span>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <span className="stat-item__status d-flex ">
                              {!this.state.isWebcam || !this.state.isScreen ?
                                <img src={calendarIcon} className="calendar" onClick={() => { this.toggleScheduleModal(dest) }} /> : ''
                              }
                            </span>
                            <div className="statusToggle d-flex p-1">
                              <ToggleButton style="left:0px;right:0px;margin:auto;"
                                value={dest.sessionStatus ? true : false}
                                onToggle={() => dest.sessionStatus ? this.facebookStartStopBroadcast(dest, true) : this.facebookStartStopBroadcast(dest)} />
                            </div>
                          </Media>)
                      }
                    }
                  }) :
                  <div>
                    {/* <img src={dashboardImage} className="dashboardImage" /> */}
                  </div>
              }
            </Media>
          </div>

          <div className="col-md-4 col-sm-10 col-xm-3 video-pannel ">
            <div className='vid' >
              {/* <div className="button-strip" >
                <div onClick={() => { this.changeWebRtmpStrip("webcam") }} className={this.state.isWebcam ? "strip-button strip-button-0" : "strip-button strip-button-0 active-strip-button"}>
                  <span className="strip-button-text">Webcam</span>
                </div>
                <div className={ "strip-button strip-button-0 active-strip-button"}>
                  <span className="strip-button-text">RTMP</span>
                </div>
              </div> */}
              <div className=' mb-3'>
                <video id="localVideo" className="video-player-poster" controls poster={offlinePoster}>
                </video>
              </div>
            </div>
            <div className="below-video-padding">
              <div className="relay-border-bottom">
                {this.state.isOnline ? <span>Acessos : {this.state.totalConnections}</span> : null}
              </div>
              <h4 className="relay-border-bottom acessos"><FontAwesomeIcon icon={faCogs} size="lg" /><span className="configuration">Configurações de Streaming</span>
              <FontAwesomeIcon  onClick={this.wowzaBitRateAjax} className="redo-icon" icon={faHistory} size="lg" /> {this.state.isOnline ? <label className="online-label">AO VIVO</label> : <label className="offline-label">OFFLINE</label>}
              </h4>
              {<RtmpConfig data={this.getRtmpConfigData()}></RtmpConfig>}
            </div>
            <div className="notificationLine">
              <h4 className="relay-border-bottom"></h4>
              <FontAwesomeIcon icon={faBullhorn} size="lg" /> NOVIDADE:
              <div className="notificationList">
                <ul className="listScrollbar" style={{ listStyleType: "none" }}>
                  {this.state.alertMessage.length ? this.state.alertMessage.map((notification, i) => {
                    return (<li key={i+'_mes'}>{notification.message}</li>)
                  }) : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Modal className="editStreamModal" isOpen={this.state.showTitleModal} toggle={this.toggleTitleModalPopup} >
          <ModalBody>
            <Form className="AddCollaboratorForm DataFields titleModal" onSubmit={this.updateTitleForAllPlatform}>
              <span onClick={this.toggleTitleModalPopup} className="titleCloseModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
              <div className="form-group">
                <label className="mr-sm-2">
                  Título</label>
                <Input type="text" name="title" id="" defaultValue={this.state.title} onChange={this.changeTitle} className="form-control" maxLength={this.state.maxTitle} showCount/>
                <div style={{ marginTop: '8px', fontSize: '14px', color: 'gray' }}>{this.state.title.length} / {this.state.maxTitle}</div>  
              </div>
              <div className="form-group">
                <label className="mr-sm-2">
                  Descrição</label>
                <Textarea
                  rows="3"
                  id="description"
                  name="description"
                  value={this.state.description}
                  onChange={this.changeDescription}
                  className="form-control input-field-textarea"
                  maxLength={this.maxDescription} 
                  showCount
                  />
                  <div style={{ marginTop: '8px', fontSize: '14px', color: 'gray' }}>{this.state.description.length} / {this.state.maxDescription}</div>  

              </div>
              <div className="form-group">
                <label className="mr-sm-2">
                  Selecione a resolução</label>
                <Select
                  type="select"
                  name="resolution"
                  id="resolution"
                  className="form-control"
                  value={this.state.selectedResolution}
                  onChange={this.selectResoultion} >
                  {this.resolutionOptions()}
                </Select>
              </div>
              <FormGroup className="text-center">
                <Button type="submit" className="updateTitle btn btn--submit mx-auto">Atualizar título das páginas</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
        <Modal className="scheduleModal" isOpen={this.state.openScheduleModal} toggle={this.toggleScheduleModal} >
          <ModalBody>
            <Form className="DataFields titleModal" onSubmit={this.addScheduleEvent}>
              <span onClick={this.toggleScheduleModal} className="titleCloseModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
              <div className="form-group">
                <label className="mr-sm-2">
                  Título</label>
                <Input type="text" name="title" id="" defaultValue={this.state.title} onChange={this.changeTitle} className="form-control" />
              </div>
              <div className="form-group">
                <label className="mr-sm-2">
                  Descrição</label>
                <Textarea
                  rows="3"
                  id="description"
                  name="description"
                  value={this.state.description}
                  onChange={this.changeDescription}
                  className="form-control input-field-textarea"
                  maxLength={3500} />
              </div>
              <div className="form-group">
                <label className="mr-sm-2">
                  Repita a programação</label>
                <Select
                  type="select"
                  name="schedule"
                  id="schedule"
                  className="form-control"
                  value={this.state.selectRepeateSchedule}
                  onChange={this.selectScheduleType} >
                  {this.scheduleOptions()}
                </Select>
              </div>
              {(this.state.selectedScheduleType == this.state.scheduleOptions[2]) ?
                <div className="form-group">
                  <MultiSelect
                    options={this.state.weekly}
                    onChange={this.selectedDays}
                    value={this.state.selectedDays}
                    placeholder="Selecionar vários dias"
                    joinValues
                    multi
                  />
                </div> : this.state.selectedScheduleType == this.state.scheduleOptions[3] ?
                  <div className="form-group">
                    <label className="mr-sm-2">
                      selecione várias datas</label>
                    <MultiSelect
                      options={this.state.dates}
                      onChange={this.selectMultipleDates}
                      value={this.state.selectedDates}
                      placeholder="selecione várias datas"
                      joinValues
                      multi
                    />
                  </div>
                  : this.state.selectedScheduleType == "Yearly" ?
                    <div className="form-group">
                      <label className="mr-sm-2">
                        Selecione a data
                      </label>
                      <DatePicker
                        locale="el"
                        className="datePicker form-control"
                        dateFormat="YYYY/MM/DD"
                        selected={moment(this.state.startDate)}
                        onChange={this.onStartDateChange}
                      />

                    </div> :
                    null}
              <div className="form-group">
                <Row>
                  <Col>
                    <label className="mr-sm-2">
                      Hora de início</label>
                  </Col>
                  <Col>
                    <Input
                      id="time"
                      label="startTime"
                      type="time"
                      value={this.state.startTime}
                      className="timeWidth"
                      onChange={this.onChangeStartTime}
                    />
                  </Col>
                </Row>
              </div>
              <div className="form-group">
                <Row>
                  <Col>
                    <label className="mr-sm-2">
                      Fim do tempo</label>
                  </Col>
                  <Col>
                    <Input
                      id="time"
                      label="startTime"
                      type="time"
                      value={this.state.endTime}
                      className="timeWidth"
                      onChange={this.onChangeEndTime}
                    />
                  </Col>
                </Row>
              </div>
              <FormGroup className="text-center">
                <Button type="submit" className="btn btn--submit mx-auto">Adicionar programação</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
        <Modal className="customRtmpModal" isOpen={this.state.instagramModal} toggle={this.disableInstagramModal} >
          <ModalBody>
            <Form className="AddCollaboratorForm DataFields" onSubmit={this.updateCustomInstagramModal}>
              <span onClick={this.disableInstagramModal} className="closeModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
              <div className="form-group">
                <Label className="mr-sm-2">
                  Destination</Label>
                <Input disabled="disabled" type="text" name="stream_key" value={this.state.instagramData.platformType} autoComplete="off" className="form-control" />
              </div>
              <div className="form-group ">
                <Label for="name" className="mr-sm-2">Name</Label>
                <Input disabled="disabled" type="text" name="rtmp_url" value={this.state.instagramData.name} autoComplete="off" className="form-control" />
              </div>
              <div className="form-group ">
                <Label for="name" className="mr-sm-2">RTMP URL</Label>
                <Input disabled="disabled" type="text" name="rtmp_url" value={this.state.instagramData.customRtmp} autoComplete="off" className="form-control" />
              </div>
              <div className="form-group ">
                <Label for="privacy" className="mr-sm-2">Stream Key</Label>
                <Input type="text" name="stream_key" value={this.state.customStreamKey} autoComplete="off" onChange={this.customSocialMediaStreamKey} className="form-control" />
              </div>
              <FormGroup className="text-center">
                <Button type="submit" className="btn btn--submit mx-auto">Atualizar</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.otpModal} >
          <ModalBody className="otpInputModal">
            <Form className="DataFields" onSubmit={this.submitInstagramOtp}>
              <span onClick={this.disableOtpInstagramModal} className="closeModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
              <div className="row">
                <div className="col-sm-3 otpInput">
                  <label className="submitButton">Digite OTP</label>
                </div>
                <div className="col-sm-6">
                  <Input type="number" name="otp" value={this.state.instagramOtp} autoComplete="off" placeholder="Digite otp de 6 dígitos" onChange={this.onChangeOtpText} className="form-control" />
                </div>
              </div>
              <FormGroup className="text-center submitButton">
                <Button type="submit" className="btn btn--submit mx-auto">Enviar</Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default DashboardDefault;



// WEBPACK FOOTER //
// ./src/components/DashboardPage/Dashboard/DashboardDefault/DashboardDefault.js